/** @format */

import React, { memo } from 'react'
import { Switch, Route } from 'react-router-dom'

import { Layout } from 'components'

export const Courses = memo(() => (
  <Switch>
    <Route path="/html/:html" component={Layout} />
    <Route path="/js/:js" component={Layout} />
    <Route path="/react/:react" component={Layout} />
    <Route path="/git/:git" component={Layout} />
    <Route path="/redux/:redux" component={Layout} />
  </Switch>
))
